<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.typeId == undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
          </template>
          <template v-slot:sorting-content>
            <!--<SortingContent :key="$route.params.filterId" />-->
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getMachineTypeListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="100" :open-function="openItem"
          :dialogItem="editItem" :dialog-trigger="dialogtrigger" :dialog-method-config="dialogMethodConfig" :pk="pk"
          @Added="i => openItem(i)">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="openItem(item)" />
          </template>

          <template v-slot:dialog-content="{ item, trigger }">
            <v-container class="px-4" v-if="item" :key="trigger">
              <v-row no-gutters>
                <v-col cols="12">
                  <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.lead.lead_type_name')"
                    externaledit :rules="[requiredRule]">
                  </QTextField>
                </v-col>
              </v-row>
            </v-container>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ListItem from "@/components/ListItems/MachineTypeListItem.vue";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";

export default {
  name: "AdminMachineTypes",
  props: {},
  components: {
    FilterPane,
    ListPane,
    Layout,
    ListItem,
    DefaultLifeCycleFilterGroup
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "MTL-",
      dialogtrigger: 1,
      editItem: {},
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createMachineType',
        },
      }
    };
  },

  methods: {
    openItem(item) {
      var query = (this.$route.name == "MachineTypes") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewMachineType', params: { typeId: item.Id }, query })
    },

    setEditItem(item) {
      if (item) {
        this.editItem = Object.assign({}, item);
      }
      else {
        var defaultItem = {
          IsActive: true,
        };
        this.editItem = defaultItem;
      }
      this.dialogtrigger++;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    externaltrigger() { return this.$store.state.triggerevents.previewTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); }
  },
};
</script>